var map = {
	"./at-the-cross.jpg": 7824,
	"./czekam-na-ciebie.jpg": 2421,
	"./dawca-drogi.jpg": 5274,
	"./dziekczynienie.jpg": 8862,
	"./grace-to-grace.jpg": 2776,
	"./in-christ-alone.jpg": 2617,
	"./it-is-so.jpg": 978,
	"./jezus-najwyzsze-imie.jpg": 1901,
	"./new-wine.jpg": 1610,
	"./nie-patrze-wstecz.jpg": 168,
	"./no-longer-slaves.jpg": 4520,
	"./only-wanna-sing.jpg": 3460,
	"./pelen-laski.jpg": 4204,
	"./podroznik.jpg": 2316,
	"./prosze-powiedz-panie.jpg": 8617,
	"./sinking-deep.jpg": 926,
	"./ufac-bede.png": 5913,
	"./you-deserve-it.jpg": 9963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2083;